import React from 'react'
import './FeatureItem.css'

const ItemData = [
    {
        itemImgPath: '/img/conditions-1.svg',
        itemTitle: "Connecting Your Business",
        itemDescription: "Australias premium party and events platform connecting millions of users to your business."
    },
    {
        itemImgPath: '/img/target.svg',
        itemTitle: "Target Customers",
        itemDescription: "Users will find your business based on location, categories and keywords."
    },
    {
        itemImgPath: '/img/cake.svg',
        itemTitle: "Display Services & Products",
        itemDescription: "Sell, hire and rent services and products your business has to offer."
    },
]

const FeatureItem = () => {
    return (
        <div className="exciting-feature-items">
            <div className="container">
                <div className="exciting-feature-items-main">
                    {/* === Feature item loop === */}
                    {
                        ItemData.map((item, itemIndex) => {
                            return(
                                <div className="exciting-feature-item" key={`EXCITINGFEATURE${itemIndex}5875GSG`}>
                                    <img src={item.itemImgPath} alt={item.itemTitle} />
                                    <h4 className="item-title">{item.itemTitle}</h4>
                                    <p className="item-description">{item.itemDescription}</p>
                                </div>
                            )
                        })
                    }
                    
                    
                </div>
            </div>
        </div>
    )
}

export default FeatureItem
